/**
 * Get query parameter value from URL
 *
 * @param url Base URL
 * @param key Query parameter key
 *
 * @returns Query parameter value
 */
export function getQueryParameterValueFromUrl(url: string, key: string): string {
    const urlParams: string[] = url?.split('?')[1]?.split('&');

    return urlParams?.find((elem) => {
        return elem?.split('=')[0] === key;
    })?.split('=')[1];
}
